import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-confirmation',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ],
  encapsulation: ViewEncapsulation.None,
})
export class TncComponent implements OnInit {
  public data: SafeHtml;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }


  ngOnInit(): void {
    this.getTncData()
  }

  public onPopOverDecline() {
    this.router.navigate(['/main/cancel-tnc-error'])
  }

  public onPopOverAccept() {
    this.router.navigate(['/account/multiple-vehicles-info']);
  }

  public getTncData() {
    this.activatedRoute.data.subscribe(({ data }) => this.data = this.sanitizer.bypassSecurityTrustHtml(data))
  }
}
